var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-bot-personal-data-agreement__wrapper"},[(_vm.iframeUrl)?_c('iframe',{staticClass:"chat-bot-personal-data-agreement__wrapper__iframe",attrs:{"src":_vm.iframeUrl,"frameborder":"0"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }